export default "__VITE_ASSET__BCdlCUUT__"